import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, FormControl, Button } from 'react-bootstrap';
import UiUtils from '../../../../utils/UiUtils';
import Session from '../../../../utils/Session';
import logo from '../../../../images/logo-app.svg';
import './TwoFactorForm.css';


class TwoFactorForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
			code: "",
			codeSize: 6,
			isSubmitDisabled: true,
        }
    }

    handleChangeCode = (event) => {
		this.setState({
			code: event.target.value,
			isSubmitDisabled: event.target.value.length != this.state.codeSize
		});
	}
	
	/**
	 * Realizo las siguientes validaciones:
	 * - Permito solo números
	 * - Permito una longitud máxima establecida en el estado del componente
	 * - Detecto la tecla Enter para enviar el código
	 * 
	 * @param {*} e 
	 */
	handleKeyPress = (e) => {
		let key = e.key;
		let regex = /[0-9]/;
		if (key === 'Enter' && ! this.isSubmitDisabled()) {
			this.entrarClickHandler();
		}
		else if(!regex.test(key) || this.state.code.length > (this.state.codeSize-1)) {
			e.preventDefault();
		}
    }

	entrarClickHandler = () => {
		if (this.state.code.length !== this.state.codeSize) {
			UiUtils.showAlert("Atención", "Verfique el código ingresado");
			return;
		}

		this.props.onTwoFactorCode(this.state.code);
	}

	isSubmitDisabled = () => {
		return (this.state.code.length != this.state.codeSize);
	}

    render() {
        return (
            <div className="container-fluid">
                <Row>
                    <div className="Absolute-Center is-Responsive">
						{Session.isMainSite() &&
							<div
								onClick={this.props.onGoBack}
								className="cursor-pointer"
							>
								<img
									className="img-responsive center-block img-logo-large"
									src={logo}
									alt="Agil Data"
								/>
							</div>
						}
                        <Col>
                            <FormGroup>
								<p style={{ color: "#fff" }} className="text-center">
									Debe escribir el código de {this.state.codeSize} dígitos que aparece en la aplicación de autenticación de su dispositivo
								</p>
								<FormControl
									placeholder="Código"
									onChange={this.handleChangeCode}
									onKeyPress={this.handleKeyPress}
									autoFocus
								/>
                            </FormGroup>
                            <FormGroup>
								<Button
									bsStyle="primary"
									className="btn-block"
									disabled={this.state.isSubmitDisabled}
									onClick={this.entrarClickHandler}>
									Enviar
								</Button>
							</FormGroup>
                            <FormGroup>
								<Button
									onClick={this.props.onGoBack}
									className="btn-block  Btn-wrap">
									Cancelar
								</Button>
							</FormGroup>
                        </Col>
                    </div>
                </Row>
            </div>
        );
    }
}

TwoFactorForm.propTypes = {
    onTwoFactorCode: PropTypes.func,
}

export default TwoFactorForm;



// WEBPACK FOOTER //
// ./src/scenes/home/components/two-factor-form/TwoFactorForm.js